export enum FieldsUuidEnum {
  PARTNERS = 'c001',
  PAYMENT = 'f001',
  TRAILER = 'v008',
  VEHICLE = 'v099',
  VEHICLE_VERSIONS = 'v005',

  PLATE = 'v001',
  BRAND = 'v003',
  MODEL = 'v004',
  FUELTYPE = 'v007',
  IMMATRICOLATION_DATE = 'v006',
  IMMOBILIZER = 'v009',
  //OPTIONALS = 'v010',
  OPTIONALS = 'v011',
  REDUCED_VAT = 'v014',
  BOX = 'v015',
  ORIGIN = 'i001',
  INSURANCE_START_DATE = 'b005',
  INSURANCE_START_HOUR = 'b006',
  INSURANCE_EXPIRE_DATE = 'b007',
  INSURANCE_CLASS = 'i002',
  INSURANCE_UNIVERSAL_CLASS = 'i003',
  CONTRACTOR_NAME = 'c002',
  CONTRACTOR_SURNAME = 'c003',
  CONTRACTOR_BIRTHDATE = 'c004',
  CONTRACTOR_ADDRESS = 'c005',
  CONTRACTOR_HOUSE_NUMBER = 'c006',
  CONTRACTOR_POSTAL_CODE = 'c007',
  CONTRACTOR_CITY = 'c008',
  CONTRACTOR_PROVINCE = 'c009',
  CONTRACTOR_TAX_CODE = 'c013',
  CONTRACTOR_EMAIL = 'c011',
  CONTRACTOR_PHONE = 'c010',
  CONTRACTOR_PHONE_INTERNATIONAL_PREFIX = 'c014',
  CONTRACTOR_PHONE_PREFIX = 'c015',
  CONTRACTOR_BASE_FIED = 'c100',

  CLASSE_MERITO = 'i003',
  LEGGE_BERSANI = 'i004',
}
